import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dreamer_type'

export default function DreamerTypePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What kind of dreamer are you?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamerType.heading')}
      buttons={[
        {
          text: `🌌 ${t('pages.onboarding.dreamerType.options.cosmicExplorer')}`,
          value: 'Cosmic explorer I love floating through weird dimensions',
          subtext: t('pages.onboarding.dreamerType.subtexts.cosmicExplorer'),
        },
        {
          text: `😱 ${t('pages.onboarding.dreamerType.options.lucidChaosRider')}`,
          value: 'Lucid chaos rider I know I am dreaming—and it s wild',
          subtext: t('pages.onboarding.dreamerType.subtexts.lucidChaosRider'),
        },
        {
          text: `🧚 ${t('pages.onboarding.dreamerType.options.symbolHunter')}`,
          value: 'Symbol hunter Every object means something. I know it',
          subtext: t('pages.onboarding.dreamerType.subtexts.symbolHunter'),
        },
        {
          text: `📓 ${t('pages.onboarding.dreamerType.options.journalKeeper')}`,
          value: 'Journal keeper I track, tag, and reflect religiously',
          subtext: t('pages.onboarding.dreamerType.subtexts.journalKeeper'),
        },
        {
          text: `🤷 ${t('pages.onboarding.dreamerType.options.stillFiguring')}`,
          value: 'Still figuring it out ',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
